const locationError = {
  alert: 'Habilite el servicio de localización de este sitio web en la configuración de su navegador',
  else: 'No fue posible acceder a su localización',
  else1: 'El servicio de geolocalización no está disponible en su navegador'
};

export default locationError;
